/* eslint-disable */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import * as React from 'react';
// import { styles as classes } from './ApplianceOptions.styles';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tooltip,
  Box,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  DialogTitle,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import Image from '../DynamicImages';
import {
  pricingHelper,
  checkModelDisabled,
  displayCurrency,
  isOptionsObject,
} from '../../utils';
import SimpleDialog from '../Dialog';

export default function ApplianceOptions({
  modelStylesData,
  modelOptions,
  onModelSelection,
  onOptionSelection,
  selectedOptions,
  setSelectionChanged,
}) {
  const [expanded, setExpanded] = React.useState('panel1');
  const [open, setOpen] = React.useState(false);
  const [dialogActions, setDailogActions] = React.useState(true);
  const [modelSelectionData, setModelSelectionData] = React.useState({});

  // console.log('modelOptions', modelOptions);

  const handleClickOpen = (id, item) => {
    // Check model is disabled and show appropriate dialog
    if (checkModelDisabled(item, selectedOptions)) {
      setDailogActions(false);
    } else {
      setDailogActions(true);
    }
    setOpen(true);
    setModelSelectionData({ id, item });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialog = () => {
    const { id, item } = modelSelectionData;
    // if model is not disabled then update the selection (Handle YES / OK button)
    if (!checkModelDisabled(item, selectedOptions)) {
      setSelectionChanged(true);
      onModelSelection(id, item);
    }
    setOpen(false);
  };

  const dialogBody = dialogActions ? (
    <>
      <DialogTitle id="alert-dialog-title">
        <Box className="TextCenter">
          Are you sure you want to change the model?
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box className="TextCenter">
            Changing the model will clear all your previous sections.
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box className="ContentCenter">
          <Button variant="contained" onClick={handleDialog}>
            Yes
          </Button>
          <Button variant="contained" onClick={handleClose}>
            No
          </Button>
        </Box>
      </DialogActions>
    </>
  ) : (
    <>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box className="TextCenter">
            Please change the oven to electric to enable this model.
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleDialog}>
          Ok
        </Button>
      </DialogActions>
    </>
  );

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const loadNestedOptions = (optionData, setSelection, selectionId) => {
    return optionData?.map((item) => {
      // for (var key of Object.keys(item)) {
      //   if (Array.isArray(item[key])) {
      //     console.log('object', key);
      //   }
      // }
      item = pricingHelper(item, selectedOptions);

      return (
        <Box key={item.id} className="ModalInfo">
          <div
            onClick={() => {
              // Open popup on change of model, if model contains data.
              // Also exclude modelPricing in case of saved data.

              // eslint-disable-next-line no-unused-vars
              const { modelPricing, ...rest } = selectedOptions;
              const filterDefaultProperty = selectedOptions?.style?.[
                'defaultProperty'
              ]
                ? Object.keys(rest)?.length > 2
                : Object.keys(rest)?.length > 1;

              if (selectionId === 'style' && filterDefaultProperty) {
                handleClickOpen(selectionId, item);
                return;
              }
              setSelection(selectionId, item);
            }}
          >
            {item.src && (
              <Tooltip
                placement="top"
                arrow
                title={isOptionsObject(item?.title, selectedOptions) || ''}
              >
                {
                  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
                  item.src == 'css' ? (
                    <div
                      className={`${item.id} ${
                        selectedOptions[selectionId]?.id === item.id
                          ? 'Active'
                          : ''
                      }`}
                    />
                  ) : (
                    <Image
                      classes={
                        selectedOptions[selectionId]?.id === item.id
                          ? 'Active'
                          : ''
                      }
                      name={item.src}
                    />
                  )
                }
              </Tooltip>
            )}
            <Typography variant="body2" textAlign="center">
              {selectionId === 'style'
                ? displayCurrency(item)
                  ? `${item?.title} ($${displayCurrency(item)})`
                  : item?.title
                : '$' + displayCurrency(item)}
            </Typography>
          </div>
        </Box>
      );
    });
  };

  const loadOptions = () => {
    return modelOptions?.map((o, index) => {
      const panelIndex = modelStylesData ? 2 : 1;
      const panel = `panel${index + panelIndex}`;
      if (o?.showStep) {
        return (
          <Accordion
            key={o.id}
            disableGutters
            elevation={0}
            square
            expanded={expanded === panel}
            onChange={handleChange(panel)}
          >
            <AccordionSummary>
              <Box className="ModalHeading">
                <Image classes="" name="images/VisualizerIconSecond.png" />
                <Typography variant="h6" textAlign="center">
                  {o.text}
                </Typography>
                {o?.showTooltip && (
                  <Tooltip
                    arrow
                    placement="top"
                    title={
                      <div className="CustomTooltip">
                        <Image name="images/Water-Jacket-Side.jpg" />
                        <div>
                          <h5>Water Jacket</h5>
                          <div>
                            Optional water jacket replaces the left side fire
                            brick and supplies hot water to your household water
                            system. The jacket supplies approximately 10 gallons
                            per hour. (Fittings, pipes, etc. not supplied.)
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <a className="InfoIconBox">
                      <InfoOutlinedIcon />
                    </a>
                  </Tooltip>
                )}
                <Typography
                  variant="body1"
                  textAlign="center"
                  className="ModalDetailInfo"
                >
                  <span className="DashBox">-</span>{' '}
                  <span className="ModalTitleName">
                    {isOptionsObject(
                      selectedOptions[o.id]?.title,
                      selectedOptions,
                    )}
                  </span>
                </Typography>
                <a className="EditButton">
                  {selectedOptions[o.id]?.id ? 'CHANGE' : 'SELECT'}
                </a>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box className="ModalBox">
                <Box className="ModalContentBox">
                  {loadNestedOptions(o.opt, onOptionSelection, o.id)}
                </Box>
              </Box>
            </AccordionDetails>
            {o?.whatsThis && (
              <a
                target="_blank"
                className="WhatThisLink"
                style={{ textDecoration: 'none' }}
                href={`${window.location.origin}${o?.whatsThis}`}
              >
                <Typography>What's this?</Typography>
              </a>
            )}
          </Accordion>
        );
      }
    });
  };

  return (
    <div>
      {modelStylesData && (
        <Accordion
          disableGutters
          elevation={0}
          square
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary>
            <Box className="ModalHeading">
              <Image classes="" name="images/VisualizerIconSecond.png" />
              <Typography variant="h6" textAlign="center">
                MODEL
              </Typography>
              <Typography
                variant="body1"
                textAlign="center"
                className="ModalDetailInfo"
              >
                <span className="DashBox">-</span>{' '}
                <span className="ModalTitleName">
                  {selectedOptions['style']?.title}
                </span>
              </Typography>
              <a className="EditButton">
                {selectedOptions['style']?.id ? 'CHANGE' : 'SELECT'}
              </a>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="ModalBox">
              <Box className="ModalContentBox">
                {loadNestedOptions(modelStylesData, onModelSelection, 'style')}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {loadOptions()}
      <SimpleDialog
        open={open}
        handleClose={handleClose}
        dialogBody={dialogBody}
      />
    </div>
  );
}

ApplianceOptions.propTypes = {
  modelStylesData: PropTypes.array,
  modelOptions: PropTypes.array,
  onModelSelection: PropTypes.func.isRequired,
  onOptionSelection: PropTypes.func.isRequired,
  selectedOptions: PropTypes.object.isRequired,
};
